import React from 'react';
import { Text } from '../../components/typography';
import styles from './RiskRegistryList.module.scss';
import { Button } from '../../components';
import { useModal } from '../../providers/ModalProvider';
import { modals } from '../../providers/modals';
import { useTranslation } from 'react-i18next';
import { keys } from '../../utilities/translator/translation_keys.js';
import RiskRegistryList from './RiskRegistryList.jsx';
import { useFlags } from 'launchdarkly-react-client-sdk';
import FlagDisabled from '../flagDisabled/FlagDisabled.jsx';
import { useCurrentUser } from '../../providers/UserProvider.jsx';

export default function RiskRegistry() {
  const { openModal } = useModal();
  const { t } = useTranslation();
  const { enableHazardLog } = useFlags();
  const { company } = useCurrentUser();

  return enableHazardLog ? (
    <div>
      <div className={styles.header}>
        <Text size="lg" weight="bold">
          {company?.riskRegistryName || 'Risk Registry'}
        </Text>
        <Button
          value={t(keys.common.NEW)}
          variant="primary"
          icon="add"
          size="md"
          onClick={() => {
            openModal({
              modalName: modals.addRiskRegistry,
            });
          }}
        />
      </div>
      <RiskRegistryList />
    </div>
  ) : (
    <FlagDisabled />
  );
}
